import { weather, type WeatherMode } from '../state/app-state.js';

const MODES: Array<{ id: WeatherMode; label: string }> = [
  { id: 'sunny', label: 'Sunny' },
  { id: 'rainy', label: 'Rainy' },
  { id: 'snowing', label: 'Snowing' },
];

export function renderWeatherPanel(host: HTMLElement): void {
  host.innerHTML = `
    <div class="panel">
      <h2>Weather</h2>
      <div class="row" id="wp-row"></div>
    </div>`;
  const row = host.querySelector<HTMLDivElement>('#wp-row')!;
  for (const m of MODES) {
    const b = document.createElement('button');
    b.className = 'button';
    b.dataset.mode = m.id;
    b.textContent = m.label;
    if (m.id === weather.get()) b.classList.add('is-active');
    row.append(b);
  }
  row.addEventListener('click', (e) => {
    const btn = (e.target as HTMLElement).closest('button[data-mode]') as HTMLButtonElement | null;
    if (!btn) return;
    const mode = btn.dataset.mode as WeatherMode;
    weather.set(mode);
    [...row.children].forEach((c) => c.classList.toggle('is-active', (c as HTMLElement).dataset.mode === mode));
  });
}
